import {throwOnErrorWithMessage} from "./api-utils"
import {ImprovementScore, ImprovementType} from "../../components-features/climate-advice/improvements/improvement-score"

export interface IImprovementsApi {
  getInitialImprovementScores(signal?: AbortSignal): Promise<ImprovementScore[]>
  getImprovementScore(improvement: ImprovementType, inputParameters: ImprovementInputParameters, signal?: AbortSignal): Promise<ImprovementScore>
}

export type ImprovementInputParameters = { [key: string]: any | null }

export class ImprovementsApi implements IImprovementsApi {
  constructor(private baseUrl: string) {
  }

  async getInitialImprovementScores(signal?: AbortSignal): Promise<ImprovementScore[]> {
    const response = await fetch(this.baseUrl + "/improvementscores/initial", {method: "get", signal, credentials: "include"})
    if (response.status === 204) return []
    await throwOnErrorWithMessage(response)
    return await response.json()
  }

  async getImprovementScore(improvement: ImprovementType, inputParameters: ImprovementInputParameters, signal?: AbortSignal): Promise<ImprovementScore> {
    const parameters = new FormData()
    Object.keys(inputParameters)
      .filter(key => inputParameters[key] !== null)
      .forEach((key: string) => {
        parameters.append(key, inputParameters[key] ?? "")
      })

    const response = await fetch(`${this.baseUrl}/improvementscores/${improvement}`, {
      method: "post",
      body: parameters,
      signal,
      credentials: "include"})
    await throwOnErrorWithMessage(response)
    return await response.json()
  }
}
